import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { faCartShopping, faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-day-purchases',
  templateUrl: './day-purchases.component.html',
  styleUrl: './day-purchases.component.scss',
  standalone: false,
})
export class DayPurchasesComponent implements OnChanges {

  protected readonly faCartShopping = faCartShopping;
  protected readonly faChevronRight = faChevronRight;

  @Input() selectedDate: any;
  @Input() selectedBranch: any;

  totalEntries: number = 0;
  totalAmount: number = 0;
  purchases: any[] = [];
  loader: boolean = false;
  scroolLoader: boolean = false;
  endOfResults: boolean = false;
  page: number = 0;
  errMsg: string = "";

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmnService: CommonServiceService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.totalEntries = 0;
      this.totalAmount = 0;
      this.purchases = [];
      this.page = 0;
      this.endOfResults = false;
      this.scroolLoader = false;
      this.getData();
    }
  }


  getData() {
    if (this.page === 0) {
      this.loader = true;
      this.errMsg = '';
      this.endOfResults = false;
      this.purchases = [];
    } else {
      this.scroolLoader = true;
    }

    let params: any = {
      created_date: this.selectedDate,
      page: this.page
    }
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    this.dayBookService.getPurchasedata(params).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.scroolLoader = false;
        const data = res.data || [];
        if (data.length === 0) {
          this.endOfResults = true;
          if (this.page === 0) {
            this.errMsg = "No data found";
          }
          return;
        }
        const tableData = this.mapResponse(data);
        this.purchases = [...this.purchases, ...tableData];
      },
      error: (err: any) => {
        this.loader = false;
        this.scroolLoader = false;
        if (this.page === 0) {
          this.errMsg = err?.error?.error?.message || "Failed to fetch response";
        }
      }
    });
  }

  mapResponse(data: any): any[] {
    if (!Array.isArray(data)) return [];
    return data.map((item: any) => {
      return {
        ...item,
        units: this.cmnService.parseNumberOrNull(item.units),
        value: this.cmnService.parseNumberOrNull(item.value)
      };
    });
  }

  onScroll() {
    if (this.endOfResults || this.scroolLoader || this.loader) return;
    this.page++;
    this.getData();
  }

  viewAllPurchases(modalContent: any) {
    this.modalService.open(modalContent, { size: 'lg', centered: true, scrollable: true });
  }

}

